<template>
  <div id="app">
    <div class="router-view">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
      <!-- BOTTOM NAVIGATION MOBILE -->
      <BottomNavigation></BottomNavigation>
    </div>
  </div>
</template>

<style lang="scss">
@import '~bootstrap/dist/css/bootstrap.min.css';
@import "./assets/sass/main.scss";
</style>

<script>
import {mapGetters} from 'vuex';
import BottomNavigation from "@/components/includes/BottomNavigation";

export default {
  name: 'App',
  components: {BottomNavigation},
  metaInfo: {
    title: 'Colorffy ',
    titleTemplate: '%s | Colorffy',
    meta: [
      //Primary Meta Tags
      {
        name: "title",
        content: "Colorffy - Create gradients and palettes."
      },
      {
        name: "description",
        content: "Create many gradients and palettes or save one of many color schemes, for everyone who needs colors."
      },
      {
        name: "keywords",
        content: "Colors, Gradients, Palettes, Color Gradients, Color Palettes, Gradients Generators, Color Codes, Random Color, Color Picker, Design, Web Design, CSS, Hex, RGB, Fresh Colors, Colors Idea, Colors Inspiration"
      },
      // Twitter Card
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:url', content: 'https://colorffy.com'},
      {name: 'twitter:title', content: 'Colorffy - Create gradients and palettes.'},
      {
        name: 'twitter:description',
        content: 'Create many gradients and palettes or save one of many color schemes, for everyone who needs colors.'
      },
      {
        name: 'twitter:image',
        content: `${window.location.protocol}//${window.location.host}` + require('./assets/seo.png')
      },
      // Facebook OpenGraph
      {property: 'og:type', content: 'website'},
      {property: 'og:url', content: 'https://colorffy.com'},
      {property: "og:title", content: "Colorffy - Create gradients and palettes."},
      {
        property: 'og:description',
        content: 'Create many gradients and palettes or save one of many color schemes, for everyone who needs colors..'
      },
      {property: 'og:site_name', content: 'Colorffy'},
      {
        property: 'og:image',
        content: `${window.location.protocol}//${window.location.host}` + require('./assets/seo.png')
      },
    ]
  },
  mounted() {
    // check for active theme
    const htmlElement = document.documentElement;
    const theme = localStorage.getItem("theme");
    if (theme === 'dark') {
      htmlElement.setAttribute('theme', 'dark')
      this.$store.commit("SET_DARK_MODE", true)
    } else {
      htmlElement.setAttribute('theme', 'light');
      this.$store.commit("SET_DARK_MODE", false)
    }


    const cookiesStatus = localStorage.getItem("cookies")
    if (cookiesStatus === 'noaccept') {
      this.$store.commit('SET_COOKIES_ACCEPTED', true)
    } else {
      this.$store.commit("SET_COOKIES_ACCEPTED", false)
    }

  },
  computed: {
    ...mapGetters(["darkMode", "cookiesToggle"]),
  },
  watch: {
    darkMode: function () {
      // add/remove class to/from html tag
      const htmlElement = document.documentElement;
      if (this.darkMode) {
        localStorage.setItem("theme", 'dark');
        htmlElement.setAttribute('theme', 'dark');
      } else {
        localStorage.setItem("theme", 'light');
        htmlElement.setAttribute('theme', 'light');
      }
    },

    cookiesToggle: function () {
      if (this.cookiesToggle) {
        localStorage.setItem("cookies", 'noaccept')
      } else {
        localStorage.setItem('cookies', 'accept')
      }
    }

  }
}
</script>